import { signal } from '@angular/core';
import { RightScope } from '../../types';
import { Rights } from './rights';
import { MyRightsForPointsDetail } from '@shared/interfaces/rights';

export class MyRightsForPoints extends Rights<MyRightsForPointsDetail> {
  protected scopes: RightScope | RightScope[] = ['points'];
  protected scopesDescription =
    'Connected user rights for points, authorized operations on them and available features';

  private _allowedStatusesIdsToChange = signal<number[]>([]);
  public allowedStatusesIdsToChange = this._allowedStatusesIdsToChange.asReadonly();

  private _allowedStatusesIdsToView = signal<number[]>([]);
  public allowedStatusesIdsToView = this._allowedStatusesIdsToView.asReadonly();

  private _allowedMattersIdsToChange = signal<number[]>([]);
  public allowedMattersIdsToChange = this._allowedMattersIdsToChange.asReadonly();

  private _allowedMattersIdsToView = signal<number[]>([]);
  public allowedMattersIdsToView = this._allowedMattersIdsToView.asReadonly();

  private _allowedAldermanIdsToChange = signal<number[]>([]);
  public allowedAldermanIdsToChange = this._allowedAldermanIdsToChange.asReadonly();

  private _allowedAldermanIdsToView = signal<number[]>([]);
  public allowedAldermanIdsToView = this._allowedAldermanIdsToView.asReadonly();

  private _allowedPointTypeIdsToChange = signal<number[]>([]);
  public allowedPointTypeIdsToChange = this._allowedPointTypeIdsToChange.asReadonly();

  private _allowedPointTypeIdsToView = signal<number[]>([]);
  public allowedPointTypeIdsToView = this._allowedPointTypeIdsToView.asReadonly();

  public setAllowedStatusesIds(statusesIds: number[]): this {
    this._allowedStatusesIdsToChange.set(statusesIds);
    return this;
  }

  public setViewableStatusesIds(statusesIds: number[]): this {
    this._allowedStatusesIdsToView.set(statusesIds);
    return this;
  }

  public setAllowedMattersIds(mattersIds: number[]): this {
    this._allowedMattersIdsToChange.set(mattersIds);
    return this;
  }

  public setViewableMattersIds(mattersIds: number[]): this {
    this._allowedMattersIdsToView.set(mattersIds);
    return this;
  }

  public setAllowedAldermanIds(aldermanIds: number[]): this {
    this._allowedAldermanIdsToChange.set(aldermanIds);
    return this;
  }

  public setViewableAldermanIds(aldermanIds: number[]): this {
    this._allowedAldermanIdsToView.set(aldermanIds);
    return this;
  }

  public setAllowedPointTypeIds(pointTypeIds: number[]): this {
    this._allowedPointTypeIdsToChange.set(pointTypeIds);
    return this;
  }

  public setViewablePointTypeIds(pointTypeIds: number[]): this {
    this._allowedPointTypeIdsToView.set(pointTypeIds);
    return this;
  }
}
